import styled from 'styled-components'
import loaderImage from '../assets/animations/spritz-logo-loop.gif'
import React from 'react'

const LoaderWrapper = styled.img`
    width: 150px;
`

export const Loader = () => <LoaderWrapper src={loaderImage} alt="Spritz logo loader" />
